const graphDropdownOptions = {
  thisWeek: 0,
  thisMonth: 1,
  threeMonths: 2,
  thisYear: 3,
  fiveYears: 4,
};
export default graphDropdownOptions;
